import { Hyperlink } from '@strata/react-hyperlink';
import { Subheading, TextScreen } from '@strata/react-page-templates';

export const TermsAndConditions = () => (
    <TextScreen
        pageTitle="Terms and Conditions"
        content={
            <>
                <Subheading text="Real Time Auth" />
                <p>
                    By submitting a referral via the Free Market Health Real Time Auth application
                    (the “Application”), the Application User consents to all terms of the Free
                    Market Health Terms of Use and Privacy Policy. The current{' '}
                    <Hyperlink linkText="Terms of Use" navUrl="terms-of-use" /> and{' '}
                    <Hyperlink linkText="Privacy Policy" navUrl="privacy-policy" /> are available
                    within the Application and at{' '}
                    <Hyperlink
                        linkText="www.freemarkethealth.com"
                        navUrl="https://www.freemarkethealth.com"
                    />
                    .
                </p>
                <p>
                    The Application User further acknowledges that a referral submitted through the
                    Application does not constitute a legal prescription. When prescribing the
                    medication associated with each referral, a prescriber is to comply with their
                    state-specific prescription requirements such as e-prescribing or state-specific
                    standards for prescription forms, fax transmissions, and other prescription
                    delivery methods.
                </p>
                <p>
                    The electronic transaction records accompanying the submission of a referral may
                    contain confidential health information that is legally privileged. This
                    information is intended only for the use of Free Market Health, the prescribing
                    provider, the related payer(s), and the servicing provider managing the
                    referral, obtained via the Free Market Health Marketplace, for the purposes of
                    coordinating care for the intended patient. Each authorized recipient of this
                    information is prohibited from disclosing this information to any other party
                    unless allowed or required to do so by law or regulation. Further, all protected
                    health information contained within such referral is subject to the business
                    associate agreement executed between Free Market Health and the organization,
                    which has provisioned access for the Application User.
                </p>
                <p>
                    Upon the submission of a referral via the Application, the Application User
                    attests that, to the best of their knowledge, all information within the
                    referral submission is accurate and complete.
                </p>
                <p>
                    All rights in the product names, trade names or logos of all third-party
                    products that appear in the Application, whether or not appearing with the
                    trademark symbol, belong exclusively to their respective owners.
                </p>
                <p className="rta_date-stamp">Last Updated: October 20, 2020</p>
            </>
        }
    />
);
